import React, { useState } from 'react';
import { MagnifyingGlassIcon } from '@heroicons/react/24/outline';
import SessionTable from '../../sessions/list/components/SessionTable';

const SORTS = {
  newest: (a, b) => new Date(b.updatedAt || 0) - new Date(a.updatedAt || 0),
  oldest: (a, b) => new Date(a.updatedAt || 0) - new Date(b.updatedAt || 0),
  title: (a, b) => (a.title || '').localeCompare(b.title || ''),
};

const matchesSearch = (session, term) => !term || [session.title, session.originalFilename, session.userName]
  .filter(Boolean).join(' ').toLowerCase().includes(term);

/** The event's sessions with a local search box and sort. */
export default function EventSessionsTab({ sessions, loading }) {
  const [search, setSearch] = useState('');
  const [sort, setSort] = useState('newest');
  const term = search.trim().toLowerCase();
  const visibleSessions = sessions.filter((s) => matchesSearch(s, term)).sort(SORTS[sort]);

  return (
    <>
      <div className="event-session-toolbar">
        <div className="event-session-search">
          <MagnifyingGlassIcon />
          <input
            type="text"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            placeholder="Search by title, file or user..."
          />
        </div>
        <select value={sort} onChange={(e) => setSort(e.target.value)}>
          <option value="newest">Newest</option>
          <option value="oldest">Oldest</option>
          <option value="title">Title A–Z</option>
        </select>
      </div>

      {loading ? (
        <div className="event-detail-empty">Loading sessions...</div>
      ) : visibleSessions.length === 0 ? (
        <div className="event-detail-empty">{term ? 'No sessions match the search.' : 'No sessions in this event yet.'}</div>
      ) : (
        <SessionTable sessions={visibleSessions} showEvent={false} />
      )}
    </>
  );
}
